export abstract class Cookie {
    private static getCookies() {
        return document.cookie.split(';').reduce(
            (all, item) => {
                const [key, value] = decodeURIComponent(item).trim().split('=');

                return [...all, { key, value }];
            },
            [] as Array<{ key: string; value: string }>
        );
    }

    public static getItem(name: string): string | null {
        const cookies = Cookie.getCookies();

        const matchedItem = cookies.find((item) => item.key === name);

        if (matchedItem) {
            return matchedItem.value;
        } else {
            return null;
        }
    }

    public static setItem(name: string, value: string, options: { path?: string; expires?: Date } = {}) {
        const THREE_DAYS_IN_MS = 3 * 24 * 60 * 60 * 1000;
        const { path = '/', expires = new Date(Date.now() + THREE_DAYS_IN_MS) } = options;

        const keyValuePart = `${name}=${value}`;
        const pathPart = `path=${path}`;
        const expiresPart = `expires=${expires.toUTCString()}`;
        const cookieParts = [keyValuePart, pathPart, expiresPart, 'SameSite=Lax', 'Secure'];

        document.cookie = cookieParts.join('; ');
    }

    public static removeItem(name: string, path = '/') {
        Cookie.setItem(name, '', { expires: new Date(0), path });
    }
}
